import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import cn from 'classnames';

import Badge from './components/Badge';
import { setBadgeCount } from '../../../../store/actions';

// import openLauncher from './images/assets/launcher_button.svg';
// import close from './images/assets/clear-button.svg';

import '../../../../../../styles.css';

const Launcher = ({ toggle, chatId, openImg, closeImg, openLabel, closeLabel, showBadge }) => {
  const dispatch = useDispatch();
  const { showChat, badgeCount } = useSelector((state) => ({
    showChat: state.behavior.showChat,
    badgeCount: state.messages.badgeCount
  }));

  const toggleChat = () => {
    toggle();
    if (!showChat) dispatch(setBadgeCount(0));
  };

  return (
    <button
      type="button"
      className={cn('rcw-launcher', { 'rcw-hide-sm': showChat })}
      onClick={toggleChat}
      aria-controls={chatId}>
      {!showChat && showBadge && <Badge badge={badgeCount} />}
      {showChat ? (
        <img
          src={closeImg || './images/assets/clear-button.svg'}
          className="rcw-close-launcher"
          alt={openLabel}
        />
      ) : (
        <img
          src={openImg || './images/assets/launcher_button.svg'}
          className="rcw-open-launcher"
          alt={closeLabel}
        />
      )}
    </button>
  );
};

export default Launcher;
